import React from "react";

const InnerColourCell = ({ backgroundColour, displayValue, focus, underline, style }) => {
  return (
    <div
      className={`inner text-light ${underline ? "underline" : ""} ${
        focus ? "focus" : ""
      }`}
      style={{
        backgroundColor: backgroundColour,
        padding: "0.3rem",
        height: "32px",
        fontWeight: "bold",
        // margin: "1px 0",
        paddingTop: "6px",
        ...style,
      }}
    >
      {displayValue || <span>&nbsp;</span>}
    </div>
  );
};

export { InnerColourCell };